import { useQuery } from './useQuery';
import { Consultation } from '../types/cabinet.types';
import { getConsultations } from '../api/cabinetApi';
import { useAuth } from './useAuth';

export const useConsultations = () => {
  const { isAuthenticated } = useAuth();

  const { data, isLoading, error, refetch } = useQuery(
    'consultations',
    getConsultations,
    isAuthenticated
  );

  const consultations = (Array.isArray(data) ? data : []).filter((c) => {
    const type = c.cardType ?? 'consultation';
    
    // Перевірка чи це послуга дієтолога (вони не мають wizytaId)
    const isDietService = c.serviceName && (
      c.serviceName.includes('Jadłospis') || 
      c.serviceName.includes('dietetyk') || 
      c.serviceName.includes('Pakiet: konsultacja')
    );

    // Фільтруємо consultation без wizytaId тільки якщо статус не pending, cancelled, та не nieudane
    // Виняток: послуги дієтолога пропускаємо, але ТІЛЬКИ якщо в них є дата консультації (c.date).
    if (isDietService && !c.date) {
      return false;
    }

    if (type === 'consultation' && !c.wizytaId && !isDietService && c.status !== 'pending' && c.status !== 'cancelled' && c.status !== 'nieudane') {
      return false;
    }
    return true;
  });

  const withWeight = consultations.filter(c => c.weight !== undefined);
  let lastWeight: number | undefined = undefined;
  for (let i = withWeight.length - 1; i >= 0; i--) {
    if (lastWeight !== undefined) {
      withWeight[i].previousWeight = lastWeight;
    }
    lastWeight = withWeight[i].weight;
  }

  const upcoming  = consultations.filter((c) => c.status === 'upcoming');
  const past      = consultations.filter((c) => c.status === 'past');
  const cancelled = consultations.filter((c) => c.status === 'cancelled');
  const pending   = consultations.filter((c) => c.status === 'pending');
  const nieudane  = consultations.filter((c) => c.status === 'nieudane');

  return {
    consultations,
    upcoming,
    past,
    cancelled,
    pending,
    nieudane,
    isLoading,
    error,
    refetch,
  };
};
